import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { iniciarSentry } from './app/services/monitoring/sentry';

if (environment.production) {
  enableProdMode();
}

// TR-22: Sentry sólo errores; sin DSN en el environment no hace nada.
iniciarSentry();

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/main.ts